



















import {Vue, Component, Prop} from 'vue-property-decorator';
import SearchHold from "@/domainObjects/hold/SearchHold";
import TicketService from "@/services/TicketService";
import Disposition from "@/domainObjects/hold/Disposition";
import HoldTicket from "@/domainObjects/hold/HoldTicket";

@Component({
})

export default class DispositionPicker extends Vue {
    @Prop({required: false}) data!: HoldTicket;
    @Prop({required: false}) selectMultiple!: Boolean;
    @Prop({required: false}) search!: SearchHold;

    private dispositions: Disposition[] = [];
    private selectedDisposition = {} as Disposition;

    mounted() {
        TicketService.getDispositions().then((response) => {
            for( let disposition of response.data ) {
                let mappedDispositions:Disposition = {id: disposition.id, desc: disposition.desc, value: disposition.id, text: disposition.desc };
                this.dispositions.push(mappedDispositions);
            }
            if (this.data && this.data.disposition && this.data.disposition.id){
                let i = this.dispositions.findIndex(disposition => disposition.value === this.data.disposition.id);
                this.selectedDisposition = this.dispositions[i];
            }
        }).catch((error)=>{

        });
    }
    selectDisposition(event){
        let value = this.dispositions.filter(disposition => disposition.id == event.target.value);
        this.$emit('selectDisposition', value[0])
    }
}
